module.exports = __webpack_public_path__ + "img/top.85bbb9c5.jpg";